import { css, StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { forwardRef } from 'react';
import { LoadingSpinner } from '../../components/LoadingSpinner';
import { AIStarsIcon } from '../../components/svgs/icons/AIStars';
import { styleSheet } from './styles';

type AiButtonProps = Omit<React.ComponentProps<'button'>, 'children' | 'className' | 'title' | 'ref'> & {
	title?: string;
	isLoading?: boolean;
	size?: 'default' | 'sm' | 'xs';
	styles?: StyleDeclarationValue[];
};

// Forwards its ref and any other button props so it can be the rendered element of a trigger, such as a Dropdown's.
export const AiButton = forwardRef<HTMLButtonElement, AiButtonProps>(
	({ title, isLoading, onClick, disabled, size = 'default', styles = [], ...props }, ref) => {
		const isDisabled = isLoading || disabled;

		return (
			<button
				{...props}
				className={css(styleSheet.button, styleSheet[size], ...styles)}
				disabled={isDisabled}
				onClick={onClick}
				ref={ref}
			>
				{
					<>
						{isLoading ? <LoadingSpinner type='tiny' /> : <AIStarsIcon stopColorOne='white' stopColorTwo='white' />}
						{title && <span>{title}</span>}
					</>
				}
			</button>
		);
	}
);
AiButton.displayName = 'AiButton';
